/** PURE_IMPORTS_START .._operators_publishReplay PURE_IMPORTS_END */
import { publishReplay as higherOrder } from '../operators/publishReplay';
/* tslint:enable:max-line-length */
/**
 * @param bufferSize
 * @param windowTime
 * @param selectorOrScheduler
 * @param scheduler
 * @return {Observable<T> | ConnectableObservable<T>}
 * @method publishReplay
 * @owner Observable
 */
export function publishReplay(bufferSize, windowTime, selectorOrScheduler, scheduler) {
    return higherOrder(bufferSize, windowTime, selectorOrScheduler, scheduler)(this);
}
//# sourceMappingURL=publishReplay.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/rxjs/_esm5/operator/publishReplay.js
// module id = null
// module chunks = 